module.exports = __webpack_public_path__ + "img/jumpsuit front centered zipper length.c398f452.png";